import axios from "axios";
import { getSiteCacheVersion } from "@/lib/siteCache";

function getBackendUrl() {
  if (typeof window !== "undefined" && window.__RUNTIME_CONFIG__?.REACT_APP_BACKEND_URL) {
    return String(window.__RUNTIME_CONFIG__.REACT_APP_BACKEND_URL).replace(/\/$/, "");
  }
  return (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
}

function getApiBase() {
  const base = getBackendUrl();
  return base ? `${base}/api` : "/api";
}

/** Resolved per-request so /runtime-config.js works without rebuild */
export function backendUrl(path = "") {
  const base = getBackendUrl();
  if (!path) return base || "";
  if (path.startsWith("http")) return path;
  const p = path.startsWith("/") ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}

export const BACKEND_URL = getBackendUrl();
export const API = getApiBase();

const api = axios.create({ timeout: 15000 });

/** Public endpoints (payment pages, no auth) */
export const publicApi = axios.create({ timeout: 15000 });

api.interceptors.request.use((config) => {
  config.baseURL = getApiBase();
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

publicApi.interceptors.request.use((config) => {
  config.baseURL = getApiBase();
  return config;
});

/** Public GET with cache-bust query param so browser never serves stale JSON. */
export async function publicGet(path, params = {}) {
  const v = getSiteCacheVersion();
  const bust = { ...params };
  if (v) bust.v = v;
  return publicApi.get(path, {
    params: bust,
    headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
  });
}

export function formatApiError(detail) {
  if (detail == null) return "خطایی رخ داد. لطفا دوباره تلاش کنید.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function mediaUrl(url, version) {
  if (!url) return "";
  if (url.startsWith("data:")) return url;
  let out = url;
  const match = url.match(/\/api\/media\/([a-f0-9-]+)/i);
  if (match) out = backendUrl(`/api/media/${match[1]}`);
  else if (url.startsWith("/api/media")) out = backendUrl(url);
  else if (!url.startsWith("http")) out = url;
  if (version && out && !out.includes("?")) {
    out = `${out}?v=${encodeURIComponent(String(version))}`;
  }
  return out;
}

export default api;
